import classNames from 'classnames';
import styles from './FormSelect.module.scss';
import { useCallback, useMemo } from 'react';
import { Select, SelectProps } from 'antd';

interface AntdSelectProps extends SelectProps {
  label?: string;
  classes?: string;
  isMulti: boolean;
  selectClasses?: string;
  values?: { label: string; value: string }[] | { label: string; value: string };
  disabledOptions?: string[];
  onBlur?: () => void;
  disabled?: boolean;
  handleChange: (value: string | string[]) => void;
  error?: { message: string | null };
}

const AntdSelect = (props: AntdSelectProps) => {
  const { options, classes, label, values, isMulti, disabled, selectClasses, handleChange, value, error } = props;

  const flattenOptions = (options: any[]): any[] => {
    return options.flatMap((opt: any) => (opt.options ? opt.options : [opt]));
  };

  const flatOptions = useMemo(() => flattenOptions(options ?? []), [options]);

  const onChange = useCallback(
    (value: any) => {
      handleChange(value);
    },
    [handleChange, name],
  );

  return (
    <div className={classNames('input', classes)}>
      <label className="input__label">
        {label && <span className="input__label-text">{label}</span>}
        <Select
          getPopupContainer={(trigger) => trigger.parentElement}
          maxTagCount="responsive"
          variant={props.variant}
          disabled={disabled}
          style={{ width: '100%', height: 50 }}
          onChange={onChange}
          options={options}
          mode={isMulti ? 'multiple' : undefined}
          defaultValue={values}
          className={classNames(selectClasses, { [styles.error]: !!error?.message })}
          value={
            Array.isArray(value)
              ? flatOptions.filter((x) => value.includes(x.value))
              : flatOptions.find((x) => x.value === value)
          }
          status={error?.message ? 'error' : undefined}
        />
      </label>
    </div>
  );
};

AntdSelect.defaultProps = {
  isMulti: false,
  menuPortal: true,
  closeMenuOnSelect: false,
};

export default AntdSelect;
